import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell, Box, Button } from '@mui/material';
import Currency from '../../common/Currency';
import MatchingStatus from '../../common/MatchingStatus';
import { incomeMatchingState, incomeRemaining } from '../../../utils/matchingState';
import { ArrowBack } from '@mui/icons-material';
import axios from 'axios';
import { isEmpty } from "lodash"
import { extension } from 'mime-types'
import SpendingDetails from '../../Spendings/SpendingDetails';
import { orderByDateAsc, orderByDateDsc } from '../../../store/actions/format';
import IncomePayments from './IncomePayments';

class IncomeSingle extends Component {
    state = {
        payments: [],
        openSpending: false,
        spending: {},
        income_sale_part: [],
        linked_sales_loading: false,
        linked_sales_error: null,
        linked_sales_modal: { open: false },
        sale_detail_modal: { open: false, item: null },
    }
    componentDidMount = () => {
        this.fetchSaleList();
    }
    fetchSaleList = async () => {
        if (!this.props.income || !this.props.income.income_id) return;
        this.setState({ linked_sales_loading: true, linked_sales_error: null });
        try {
            const res = await axios.get(`/incomes/${this.props.income.income_id}/linked-sales`);
            this.setState({
                income_sale_part: Array.isArray(res.data) ? res.data : [],
                linked_sales_loading: false,
            });
        } catch (err) {
            console.error("fetchSaleList error", err);
            this.setState({
                income_sale_part: [],
                linked_sales_error: "Impossible de charger les ventes 8000 liées",
                linked_sales_loading: false,
            });
        }
    }
    openLinkedSalesModal = () => {
        this.setState({ linked_sales_modal: { open: true } });
    }
    closeLinkedSalesModal = () => {
        this.setState({ linked_sales_modal: { open: false } });
    }
    openSaleDetailModal = (item) => {
        this.setState({ sale_detail_modal: { open: true, item } });
    }
    closeSaleDetailModal = () => {
        this.setState({ sale_detail_modal: { open: false, item: null } });
    }
    displayProjects = (projects) => {
        const { PROJECTS } = this.props;
        console.log('====================================');
        console.log(projects, PROJECTS);
        console.log('====================================');
        return projects.split(', ').map(project => PROJECTS && PROJECTS[project] && PROJECTS[project].project_name)
    }
    displayChantiers = (chantiers) => {
        const { CHANTIERS } = this.props;
        console.log('====================================');
        console.log(chantiers, CHANTIERS);
        console.log('====================================');
        return chantiers.split(', ').map(chantier => CHANTIERS && CHANTIERS[chantier] && CHANTIERS[chantier].chantier_name)
    }
    render() {
        const { income, BANKS, POSTS, CHANTIERS } = this.props
        console.log('====================================');
        console.log({income});
        console.log('====================================');
        return (
            <Fragment>
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
                scroll="paper"
            >
                <DialogTitle >
                    <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                        <ArrowBack /> 
                    </IconButton>
                    Recette n° {income.income_ref}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* <Typography variant="h6" style={{textAlign: "center"}}><Currency value={income.income_amount} /></Typography>
                    <Divider /> */}
                    <Grid container spacing={2} style={{marginTop: "20px"}}>
                        <Grid item xs={12} sm={6}>
                            
                            <Table className="table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Montant</Typography></TableCell>
                                        <TableCell><Currency value={income.income_amount} /></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="button">Pointage</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <MatchingStatus
                                                state={incomeMatchingState(income)}
                                                showRemaining={false}
                                                showLabel
                                            />
                                        </TableCell>
                                    </TableRow>
                                    {incomeRemaining(income) > 0 &&
                                        <TableRow>
                                            <TableCell>
                                                <Typography variant="button">Restant à pointer</Typography>
                                            </TableCell>
                                            <TableCell><Currency value={incomeRemaining(income)} /></TableCell>
                                        </TableRow>
                                    }
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Payé le:</Typography>
                                        </TableCell>
                                        <TableCell>{new Date(income.income_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Banque</Typography>
                                        </TableCell>
                                        <TableCell>
                                            {income.income_bank && BANKS[income.income_bank].bank_name}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Poste</Typography>
                                        </TableCell>
                                        <TableCell>
                                            {income.income_post && POSTS[income.income_post].post_name}
                                        </TableCell>
                                    </TableRow>
                                    {income.income_project &&
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Projets</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {income.income_project && this.displayProjects(income.income_project).join(", ")}
                                            </TableCell>
                                        </TableRow>
                                    }
                                    {income.income_chantier &&
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Chantiers</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {income.income_chantier && this.displayChantiers(income.income_chantier).join(", ")}
                                            </TableCell>
                                        </TableRow>
                                    }
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="button">Description</Typography>
                                        </TableCell>
                                        <TableCell>
                                            {income.income_desc}
                                        </TableCell>
                                    </TableRow>
                                    {this.props.view === "ADMIN" && (
                                        <TableRow>
                                            <TableCell>
                                                <Typography variant="button">Ventes 8000</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {this.state.linked_sales_loading
                                                    ? <Typography variant="body2" color="textSecondary">Chargement…</Typography>
                                                    : this.state.linked_sales_error
                                                        ? <Typography color="error" variant="body2">⚠️ {this.state.linked_sales_error}</Typography>
                                                        : isEmpty(this.state.income_sale_part)
                                                            ? <Typography variant="body2" color="textSecondary">Aucune vente 8000 liée</Typography>
                                                            : (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={this.openLinkedSalesModal}
                                                                >
                                                                    Voir les ventes 8000 liées ({this.state.income_sale_part.length})
                                                                </Button>
                                                            )
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            {income.income_files &&
                                <Grid container spacing={3}>
                                    {income.income_files.map( (photo, index) => (
                                        <Fragment>
                                            {photo.filetype === "application/pdf" &&
                                                <Grid key={photo.filename} item xs={12} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <embed 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            width="100%" 
                                                            height="400px" 
                                                            title={`fichier${index + 1}`} 
                                                            type="application/pdf"
                                                        />
                                                    </a>
                                                </Grid>
                                            }

                                            {photo.filetype !== "application/pdf" &&
                                                <Grid key={photo.filename} item xs={6} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <img 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            title={`fichier${index + 1}`} 
                                                            alt={`fichier${index + 1}`} 
                                                        />
                                                    </a>
                                                </Grid>
                                            }
                                        </Fragment>                          
                                        )) }
                                </Grid>
                            }
                

                        </Grid>
                        
                    </Grid>
                    <br />
                    <Divider />
                    <Box p={1}>
                        <Typography variant="body1" style={{textAlign: "center", fontWeight: "700"}}>Paiements Liés</Typography>

                        {income.income_amount !== income.income_total_available &&
                            <IncomePayments open={true} handleClose={this.handleClose} {...this.props} income={income} />
                        }
                    </Box>
                    
                    
                    {/* 
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3} style={{textAlign: "center", fontWeight: "700"}}>Paiements Liés</TableCell>
                                ...
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        </TableBody>
                    </Table>
                     */}
                </DialogContent>
            </Dialog>
            {this.state.linked_sales_modal.open && (
                <Dialog
                    open
                    onClose={this.closeLinkedSalesModal}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>Ventes 8000 liées à cette recette</DialogTitle>
                    <DialogContent>
                        {this.state.linked_sales_loading &&
                            <Typography>Chargement des ventes liées…</Typography>
                        }
                        {this.state.linked_sales_error &&
                            <Typography color="error">{this.state.linked_sales_error}</Typography>
                        }
                        {!this.state.linked_sales_loading
                            && !this.state.linked_sales_error
                            && isEmpty(this.state.income_sale_part) &&
                            <Typography>Aucune vente 8000 liée à cette recette.</Typography>
                        }
                        {!isEmpty(this.state.income_sale_part) &&
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date vente</TableCell>
                                        <TableCell>Client</TableCell>
                                        <TableCell align="right">Montant rattaché</TableCell>
                                        <TableCell align="right">Prix vente total TTC</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { this.state.income_sale_part.map(item => {
                                        const items = item.items || [];
                                        const canOpen = items.length > 0;
                                        return (
                                            <TableRow
                                                hover
                                                key={item.sale_id}
                                                style={{
                                                    cursor: canOpen ? "pointer" : "default",
                                                    ...(item.status === "orphan" ? { opacity: 0.6 } : {}),
                                                }}
                                                onClick={canOpen ? () => this.openSaleDetailModal(item) : undefined}
                                            >
                                                <TableCell>
                                                    {item.sale_date
                                                        ? new Date(item.sale_date).toLocaleDateString("fr-FR")
                                                        : "—"}
                                                </TableCell>
                                                <TableCell>{item.client_name || "—"}</TableCell>
                                                <TableCell align="right">
                                                    <Currency value={item.link_amount} />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {item.sale_total_amount
                                                        ? <Currency value={item.sale_total_amount} />
                                                        : "—"}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }) }
                                </TableBody>
                            </Table>
                        }
                        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <Button onClick={this.closeLinkedSalesModal} color="primary">
                                Fermer
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
            {this.state.sale_detail_modal.open && this.state.sale_detail_modal.item && (
                <Dialog
                    open
                    onClose={this.closeSaleDetailModal}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        Détails de la vente 8000
                        <Typography variant="body2" color="textSecondary">
                            {this.state.sale_detail_modal.item.sale_date
                                ? new Date(this.state.sale_detail_modal.item.sale_date).toLocaleDateString("fr-FR")
                                : "—"}
                            {" — "}
                            {this.state.sale_detail_modal.item.client_name || "—"}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, fontFamily: "monospace" }}>
                            ID vente : {this.state.sale_detail_modal.item.sale_id}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        {isEmpty(this.state.sale_detail_modal.item.items)
                            ? <Typography>Aucun item pour cette vente.</Typography>
                            : (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Produit</TableCell>
                                            <TableCell align="right">Quantité</TableCell>
                                            <TableCell align="right">Prix unitaire</TableCell>
                                            <TableCell align="right">Total TTC</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.sale_detail_modal.item.items.map((sub, idx) => (
                                            <TableRow key={sub.product_id ? `${sub.product_id}-${idx}` : `item-${idx}`}>
                                                <TableCell>{sub.product_name || sub.product_id || "—"}</TableCell>
                                                <TableCell align="right">{sub.quantity}</TableCell>
                                                <TableCell align="right">
                                                    {sub.unit_price
                                                        ? <Currency value={sub.unit_price} />
                                                        : "—"}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {sub.total_price
                                                        ? <Currency value={sub.total_price} />
                                                        : "—"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )
                        }
                        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <Button onClick={this.closeSaleDetailModal} color="primary">
                                Fermer
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
            </Fragment>
        );
    }
}

export default IncomeSingle;